<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <p>{{ text }}</p>
  <mat-form-field appearance="fill">
    <mat-label>Select a date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [min]="minDate" [max]="maxDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancelClick()" cdkFocusInitial color="accent">{{ cancel }}</button>
  <button mat-raised-button (click)="onConfirmClick()" color="primary">{{ confirm }}</button>
</div>
